import {isMobile} from "react-device-detect";
import Skeleton from '@mui/material/Skeleton';

export default function PreloaderTopPagePicture() {
    return <div className='TopPagePicture'>
        <Skeleton variant="rectangular" width="100%" height={isMobile ? 130: 370} style={{marginBottom: '2rem'}} />
    </div>
}
